<script setup>
import {computed} from 'vue';

const props = defineProps({
  ladderPositionChange: {
    type: Object,
    required: true
  }
});
const color = computed(() => {
  if (props.ladderPositionChange.oldPosition > props.ladderPositionChange.newPosition) {
    return 'tl-chip--ok';
  } else if (props.ladderPositionChange.oldPosition < props.ladderPositionChange.newPosition) {
    return 'tl-chip--warn';
  } else {
    return 'tl-chip--brand';
  }
});
const icon = computed(() => {
  if (props.ladderPositionChange.oldPosition > props.ladderPositionChange.newPosition) {
    return 'mdi-arrow-up';
  } else if (props.ladderPositionChange.oldPosition < props.ladderPositionChange.newPosition) {
    return 'mdi-arrow-down';
  } else {
    return 'mdi-equals';
  }
});
const explanation = computed(() => {
  if (props.ladderPositionChange.oldPosition === props.ladderPositionChange.newPosition) {
    return "No change";
  }
  var difference = Math.abs(props.ladderPositionChange.oldPosition - props.ladderPositionChange.newPosition);
  return "Moved " + (props.ladderPositionChange.oldPosition > props.ladderPositionChange.newPosition ? "up" : "down") + " ladder " + difference + " position" + (difference > 1 ? "s" : "") + " from position " + props.ladderPositionChange.oldPosition + " to " + props.ladderPositionChange.newPosition;
})
</script>

<template>
  <span>
    <v-tooltip>
      <template v-slot:activator="{ props }">
        <span v-bind="props" class="tl-chip" :class="color">
          <v-icon size="10" icon="mdi-ladder"/>
          <span>{{ ladderPositionChange.oldPosition }}</span>
          <v-icon :icon="icon"/>
          <span>{{ ladderPositionChange.newPosition }}</span>
        </span>
      </template>
      <template #default>
          {{ explanation }}
      </template>
    </v-tooltip>
    </span>
</template>

<style scoped lang="scss">
.tl-chip {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 1px 6px;
  border-radius: 999px;
  line-height: 1.4;
}
</style>
